'use client';

import ActionButton from '@/components/form/ActionButton/ActionButton';
import LinkButton from '@/components/form/LinkButton/LinkButton';
import layoutStyles from '@/styles/modules/layout.module.scss';
import utilsStyles from '@/styles/modules/utils.module.scss';
import { setCookie } from '@/utils/cookie';
import type { Route } from 'next';
import Link from 'next/link';
import styles from './FanyForm.module.scss';

const FanyForm = ({
  fanyLoginUrl,
  fanyParam,
  fanySiteId,
  fanyLoginUrlForSignup,
  fanyParamForSignup,
  fanySiteIdForSignup,
  envName,
  redirectPath,
}: {
  fanyLoginUrl: string;
  fanySiteId: string;
  fanyParam: string;
  fanyLoginUrlForSignup: string;
  fanyParamForSignup: string;
  fanySiteIdForSignup: string;
  envName?: string;
  redirectPath: string;
}) => {
  const goFanySignup = () => {
    // 既にログイン用の静的なフォームで利用してしまっているので、完全に別でformを作成して遷移させる
    const actionUrl = fanyLoginUrlForSignup ?? '';
    if (actionUrl === '') return;

    const form = document.createElement('form');
    form.method = 'post';
    form.action = actionUrl;
    form.style.display = 'none';

    const paramInput = document.createElement('input');
    paramInput.type = 'hidden';
    paramInput.name = 'param';
    paramInput.value = fanyParamForSignup;
    form.appendChild(paramInput);

    const siteInput = document.createElement('input');
    siteInput.type = 'hidden';
    siteInput.name = 'site';
    siteInput.value = fanySiteIdForSignup;
    form.appendChild(siteInput);

    document.body.appendChild(form);
    form.submit();
  };

  setCookie('callback_path', redirectPath);

  return (
    <form action={fanyLoginUrl} method='post'>
      <input type='hidden' name='param' value={fanyParam} />
      <input type='hidden' name='site' value={fanySiteId} />
      <div className={`${utilsStyles.mtMedium}  ${utilsStyles.centeredVertical}`}>
        <div className={styles.termsWrapper}>
          <p className={`${utilsStyles.mtXSmall} ${utilsStyles.textSmall}`}>
            ご利用には吉本興業株式会社が提供している「FANY ID」と、
            <br />
            フォッグ株式会社が提供しているButterflyIDの登録および連携が必要になります。
          </p>
          <br />
          <p className={`${utilsStyles.textSmall}`}>
            FANY Chanceを初めてご利用する方は、
            <br className={utilsStyles.onlySp} />
            ButterflyIDの
            <Link href={`${process.env.NEXT_PUBLIC_MAIN_URL}/terms` as Route} className={utilsStyles.textLink}>
              利用規約
            </Link>
            、
            <br className={utilsStyles.onlyPc} />
            FANY Chanceの
            <Link href='/terms' className={utilsStyles.textLink}>
              利用規約
            </Link>
            と
            <br className={utilsStyles.onlySp} />
            <Link href='/policy' className={utilsStyles.textLink}>
              個人情報の取扱い
            </Link>
            に同意の上、
            <br className={utilsStyles.onlyPc} />
            下記ボタンより登録をお願いします。
          </p>
        </div>
      </div>

      <>
        <div className={`${layoutStyles.centeredBtnWrapper} ${utilsStyles.mtMedium}`}>
          <p className={`${utilsStyles.textLarge} ${utilsStyles.textBold}`}>FANY IDをお持ちの方</p>
          <ActionButton type='submit' color='primary'>
            FANY ID でログイン
          </ActionButton>
          {envName === 'local' && (
            <LinkButton href={`/auth/signin/butterfly?callbackUrl=${encodeURIComponent(redirectPath)}`}>
              Butterfly ID でログイン
            </LinkButton>
          )}
          <p className={`${utilsStyles.textLarge} ${utilsStyles.textBold}`}>FANY IDをお持ちでない方はこちら</p>
        </div>
        <div className={`${layoutStyles.centeredBtnWrapper} ${utilsStyles.mtSmall}`}>
          <ActionButton onClick={goFanySignup} color='primary'>
            FANY ID 新規会員登録
          </ActionButton>
        </div>
      </>
    </form>
  );
};
export default FanyForm;
